/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AdminState, IUsers } from './admin.types'

const initialState = { users: [] } as AdminState

export const admin = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        setUserList: (state: any, action: PayloadAction<any[]>) => {
            const data = action.payload
            return {
                ...state,
                users: data,
            } as IUsers
        },
        cleanUsers: () => ({
            users: [],
        }),
    },
})

export const { setUserList, cleanUsers } = admin.actions
export default admin.reducer
